module.exports = __webpack_public_path__ + "static/img/idcard-backend.baad3e4b.png";